import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  qatar_logo: require("../../../assets/wc/images/sport_world_logo.png"),
};

export default assets;
